import script from "./Traning.vue?vue&type=script&setup=true&lang=js"
export * from "./Traning.vue?vue&type=script&setup=true&lang=js"

import "./Traning.vue?vue&type=style&index=0&id=0c4f8c4e&lang=css"

const __exports__ = script;

export default __exports__